import React, { useEffect, useState } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { FailedSolutions } from '../components/sales/FailedSolutions';
import { MechanismSection } from '../components/sales/MechanismSection';
import { WhatYouGet } from '../components/sales/WhatYouGet';
import { AudienceSection } from '../components/sales/AudienceSection';
import { HowItWorks } from '../components/sales/HowItWorks';
import { ProofSection } from '../components/sales/ProofSection';
import { FAQSection } from '../components/sales/FAQSection';
import { OfferBlock } from '../components/sales/OfferBlock';
import { StickyBar } from '../components/sales/StickyBar';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  const [showStickyBar, setShowStickyBar] = useState(false);
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky bar after scrolling past the hero section (approx 600px)
      // and hide it when reaching the bottom offer block
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      // Calculate if we're near the bottom offer block
      const isNearBottom = scrollPosition + windowHeight > documentHeight - 800;
      if (scrollPosition > 600 && !isNearBottom) {
        setShowStickyBar(true);
      } else {
        setShowStickyBar(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <main className="min-h-screen bg-[#FCFCFA] font-sans selection:bg-forest-200 selection:text-forest-900" data-id="element-229">
      <HeroSection data-id="element-230" />
      <ProblemSection data-id="element-231" />
      <FailedSolutions data-id="element-232" />
      <MechanismSection data-id="element-233" />
      <WhatYouGet data-id="element-234" />
      <AudienceSection data-id="element-235" />
      <HowItWorks data-id="element-236" />
      <ProofSection data-id="element-237" />
      <FAQSection data-id="element-238" />
      <OfferBlock data-id="element-239" />
      <Footer data-id="element-240" />
      <StickyBar isVisible={showStickyBar} data-id="element-241" />
    </main>;
}